module.exports = __webpack_public_path__ + "95041da74ad4e7c44aace389ce6cbe5d.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/goed_zo_2.mp3
// module id = 73
// module chunks = 0